function disableInputs(form, formType) {
  const name = `${form}_${formType}`;

  $(`#${name}_admin_is_the_same_from_access_right`).removeClass('is-invalid');
  $(`#${name}_admin_is_the_same_from_relationship`).removeClass('is-invalid');
  $(`#${name}_access_right_responsible_is_the_same_from_relationship`).removeClass('is-invalid');
  $(`#${name}_name`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_document_number`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_birth_date`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_rg`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_contact_phone_number`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_contact_email`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_contact_phone_number`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_zip_code`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_municipality`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`.${name}_address_state select`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_street`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_neighborhood`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_number`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`#${name}_address_complement`).attr('disabled', 'disabled').removeClass('is-invalid');
  $(`input[name='${form}[${formType}][declared_pep]']`).attr('disabled', 'disabled').removeClass('is-invalid');
  $('fieldset.form-group-invalid .d-block').removeClass('d-block');
}

function goToByScroll(selector) {
  $('html,body').animate({
    scrollTop: $(selector).offset().top,
  }, 'slow');
}

function enableInputs(form, formType) {
  const name = `${form}_${formType}`;

  $(`#${name}_name`).removeAttr('disabled');
  $(`#${name}_document_number`).removeAttr('disabled');
  $(`#${name}_birth_date`).removeAttr('disabled');
  $(`#${name}_rg`).removeAttr('disabled');
  $(`#${name}_contact_phone_number`).removeAttr('disabled');
  $(`#${name}_contact_email`).removeAttr('disabled');
  $(`#${name}_contact_phone_number`).removeAttr('disabled');
  $(`#${name}_address_zip_code`).removeAttr('disabled');
  $(`#${name}_address_municipality`).removeAttr('disabled');
  $(`.${name}_address_state select`).removeAttr('disabled');
  $(`#${name}_address_street`).removeAttr('disabled');
  $(`#${name}_address_neighborhood`).removeAttr('disabled');
  $(`#${name}_address_number`).removeAttr('disabled');
  $(`#${name}_address_complement`).removeAttr('disabled');
  $(`input[name='${form}[${formType}][declared_pep]']`).removeAttr('disabled');
}

$(document).ready(() => {
  if ($('.new_access_request').length > 0) {
    $('#access_request_access_right_responsible_access_right_responsible_is_the_same_from_relationship')
      .on('change rightnow', (event) => {
        const checked = event.currentTarget.checked;

        if (checked) {
          disableInputs('access_request', 'access_right_responsible');

          goToByScroll('.documents_section');
        } else {
          enableInputs('access_request', 'access_right_responsible');
        }
      }).triggerHandler('rightnow');

    $('#access_request_admin_admin_is_the_same_from_access_right').on('change rightnow', (event) => {
      const checked = event.currentTarget.checked;

      if (checked) {
        disableInputs('access_request', 'admin');
        $('#access_request_admin_admin_is_the_same_from_relationship').prop('checked', false);

        goToByScroll('.card-footer');
      } else {
        enableInputs('access_request', 'admin');
      }
    }).triggerHandler('rightnow');

    $('#access_request_admin_admin_is_the_same_from_relationship').on('change rightnow', (event) => {
      const checked = event.currentTarget.checked;

      if (checked) {
        disableInputs('access_request', 'admin');
        $('#access_request_admin_admin_is_the_same_from_access_right').prop('checked', false);

        goToByScroll('.card-footer');
      } else {
        enableInputs('access_request', 'admin');
      }
    }).triggerHandler('rightnow');

    $('select#access_request_kind').on('change', (event) => {
      const value = $(event.currentTarget).find('option:selected').val();

      if (value === 'registration_participant') {
        $('#access_request_participant_document_number')
          .addClass('d-none')
          .hide()
          .parent()
          .parent()
          .addClass('d-none')
          .hide();
      } else {
        $('#access_request_participant_document_number')
          .removeClass('d-none')
          .show()
          .parent()
          .parent()
          .removeClass('d-none')
          .show();
      }
    });
  }

  $('.has-tip').each(function () {
    let labelElement = $(this).prevAll('label').first();
    const title = $(this).attr('title');
    $(this).removeAttr('title');
    $(this).removeClass('has-tip');

    if (labelElement.length === 0) {
      labelElement = $(this).parent().prevAll('label').first();
    }

    labelElement.append(`<span data-toggle="tooltip" title="${title}"> ⓘ</span>`);
  });
});
